// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"19981":"7db0e353f13f4efc","38861":"7427a3d7ab30e1e5","47477":"b5ae8e01b1b01901","71003":"9eb37029a6421129","94005":"769ac963532956e9"}[chunkId] + ".css";
};